import { apiRequest } from '../index'
import type { ApiResponse } from '@core/types'

/** 后端登录响应 */
export interface LoginResponse {
    token: string
    user: BackendUser
}

/** 后端用户结构 (匹配 SingleUserResponse DTO) */
export interface BackendUser {
    id: string
    account: string
    nickname: string
    isAdmin: number
    avatar?: string
    rolesID: string[]
    interfaceDic: string[]
    departmentID?: string
    createTime?: string
    updateTime?: string
    status: string
}

/** 登录 */
export async function login(account: string, password: string, captcha: string, captchaId: string): Promise<ApiResponse<LoginResponse>> {
    return apiRequest<LoginResponse>('/auth/login', {
        method: 'POST',
        body: { account, password, captcha, captchaId },
        auth: false,
    })
}

/** 获取验证码 ID */
export async function fetchCaptcha(): Promise<ApiResponse<{ captchaId: string }>> {
    return apiRequest<{ captchaId: string }>('/auth/captcha', { auth: false })
}

/** 根据 ID 获取验证码图片 URL */
export function getCaptchaImageUrl(captchaId: string): string {
    const base = import.meta.env.VITE_API_BASE_URL || '/factory-api'
    return `${base}/auth/captcha/image/${captchaId}`
}

/** 设置文件下载 Cookie */
export async function setCookie(): Promise<ApiResponse<string>> {
    return apiRequest<string>('/auth/cookie')
}
